module.exports = __webpack_public_path__ + "img/pinterest.81c9c70c.svg";